import React from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const NoAvailability = ({
  provider,
  nextAvailability,
  fastForwardDateRange,
  referPatientCallback,
  classes,
}) => {
  const hasNextAvailability = !isEmpty(nextAvailability);
  const key = `next-availability-${nextAvailability.start}`;

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.emptyGrid}
    >
      {hasNextAvailability ? (
        <Typography variant="h6" align="center">
          <Button
            key={key}
            className={classes.availabilityButton}
            onClick={() =>
              fastForwardDateRange({ startDate: nextAvailability.start })
            }
          >
            Next availability is{' '}
            {moment.utc(nextAvailability.start).format('ddd, MMM D')}
          </Button>
        </Typography>
      ) : (
        <Typography variant="h6" align="center">
          {provider.fullTitle} has not yet entered upcoming availability.
          <br />
          Please{' '}
          <span
            onClick={() => referPatientCallback(provider)}
            rel="noopener noreferrer"
            className="external-link"
          >
            click here
          </span>{' '}
          to contact their office requesting an appointment.
        </Typography>
      )}
    </Grid>
  );
};

NoAvailability.propTypes = {
  provider: PropTypes.object.isRequired,
  nextAvailability: PropTypes.object.isRequired,
  fastForwardDateRange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isSearchPage: PropTypes.bool,
};

const styles = () => ({
  emptyGrid: {
    minHeight: '100%', // This number is height of the grid container minus the height of the date range
  },
  availabilityButton: {
    marginBottom: '8px',
    padding: '8px 16px',
    color: 'white',
    borderRadius: '2px',
    fontSize: '14px',
    lineHeight: '21px',
    backgroundColor: '#0077bd',
  },
  requestAppointmentButton: {
    backgroundColor: '#0277bd',
    fontSize: '1.25em',
  },
});

export default withStyles(styles)(NoAvailability);
